$('.add-to-basket-btn').on('click', function (event) {
    event.preventDefault();

    //check quantity has been set in atleast 1 size
    var sizeQuantity = $(".sizes_to_change input[type='number']").filter(function(){
        return +this.value > 0;
    }).length;

    if (sizeQuantity > 0) {
        
        var $this = $(this);
        let postData = $this.closest('form[name="selected_product_options"]').serialize();

        if ($this.hasClass('add-logo')) {
            postData += "&add-logo";
        }

        $.ajax({
            type: 'POST',
            url: $(document.body).data('base') + '/ajax/product/add-to-cart.php',
            data: postData,
            success: function(response) {
                response = JSON.parse(response);

                if (response.redirect) {
                    window.location.href = response.redirect;
                    return true;
                }

                swal({
                    title: '',
                    type: response.status,
                    text: response.message,
                    confirmButtonText: 'Go To Checkout',
                    cancelButtonText: 'Continue Shopping',
                    confirmButtonColor: "#f15a24",
                    showCancelButton: true,
                    showConfirmButton: (response.status == 'success') ? true : false
                }, function(isConfirm)
                {
                    if(isConfirm) {
                        window.location.href = $(document.body).data('base') + '/cart';
                    } else {
                        $this.closest('form[name="selected_product_options"]').trigger("reset");
                        if(response.status !== 'success') {
                            location.reload();
                        }
                    }
                });
            },
            error: function() {
                console.log('Ajax request not received');
            }
        });

    } else {
        swal({
            title: "Error",
            text: "Please select the size[s] you would like",
            type: "error",
            confirmButtonColor: "#f15a24"
        });
    }

    //stop form submitting
    return false;

});

$('.remove-product').click(function() {
     var $this = $(this);

     $.ajax({
        type: 'POST',
        url: $(document.body).data('base') + '/ajax/product/remove-from-cart.php',
        data: {
          cartKey: $this.attr('cart-id'),
          bundleID: $this.attr('bundle-id')
        },
        success: function(response) {
          response = JSON.parse(response);

          if(response.status !== 'success') {
            swal('', response.message, response.status);
          } else {
            location.reload();
          }
        },
        error: function() {
          console.log('Ajax request not received');
        }
     });
});

$('.js-update-quantity').click(function() {
    $('.cart__left input[name="quantity"]').each(function(){
        $input = $(this);
        $.ajax({
          type: 'POST',
          url: $(document.body).data('base') + '/ajax/product/update-cart-quantity.php',
          data: {
            cartKey: $(this).attr('cart-id'),
            quantity: $(this).val()
          },
          success: function(response) {
            response = JSON.parse(response);
            if(response.status !== 'success') {
            if(response.current_stock != '') {
                $input.val(response.current_stock);
            }
              swal('', response.message, response.status);
            } 
            else {
              location.reload();
            }
          }
        });
    });
});

$('input[type="text"].form__input--quantity').on('change', function() {
    $input = $(this);
    $.ajax({
      type: 'POST',
      url: $(document.body).data('base') + '/ajax/product/update-cart-quantity.php',
      data: {
        cartKey: $(this).attr('cart-id'),
        quantity: $(this).val()
      },
      success: function(response) {
        response = JSON.parse(response);

        if(response.status !== 'success') {
            if(response.current_stock != '') {
                $input.val(response.current_stock);
            }
          swal('', response.message, response.status);
        } 
        else {
          location.reload();
        }
      }
    });
});

var $cart_promo_code = $('form[name="cart_promotion_code"]');
$cart_promo_code.validate({
    rules: {
        code: {
            required: true,
        }
    },
    submitHandler: function() {

        $.ajax({
            type: 'POST',
            url: $(document.body).data('base') + '/ajax/product/apply-discount.php',
            data: $cart_promo_code.serialize(),
            success: function(response) {
                response = JSON.parse(response);

                swal({
                    title: response.title,
                    text: response.message,
                    type: response.status,
                    confirmButtonColor: "#f15a24"
                }, function() {
                    if('success' == response.status) {
                        location.reload();
                    }
                })
            },
            error: function() {
                console.log('Ajax request not received');
            }
        });

        return false;
    }
});

$('.auto-prefill-address').on('change',function () {
    var address1 = $(this).find(':selected').data('line_one');
    var address2 = $(this).find(':selected').data('line_two');
    var county = $(this).find(':selected').data('line_three');
    var city = $(this).find(':selected').data('city');
    var postcode = $(this).find(':selected').data('postcode');
    var type = $(this).find(':selected').data('type');
    var country = $(this).find(':selected').data('country');

    $('input[name="'+type+'[address][line_one]"]').val(address1);
    $('input[name="'+type+'[address][line_two]"]').val(address2);
    $('input[name="'+type+'[address][line_three]"]').val(county);
    $('input[name="'+type+'[address][city]"]').val(city);
    $('input[name="'+type+'[address][postcode]"]').val(postcode);
    $('select[name="'+type+'[address][country]"]').val(country).trigger('change');
});

$('.delivery-country').on('change',function () {
    $('.preloader').css('display', 'block');

    $.ajax({
      type: 'POST',
      url: $(document.body).data('base') + '/ajax/product/change-delivery-costs.php',
      data: {
        country: $(this).val()
      },
      success: function(response) {
        response = JSON.parse(response);

        $('.checkout-delivery span').html(response.delivery_total);
        $('.checkout-vat span').html(response.vat_total);
        $('.checkout-total span').html(response.grand_total);
        $('.checkout-discount span').html(response.discount_total);
        $('.preloader').css('display', 'none');

        $('select[name="change_delivery"]').html('').select2();
        $.each( response.services, function( i, val ) {
            var newOption = new Option(val['name']+' ('+val['working_days']+' Working Days) - '+val['price'], val['id'], false, false);
            $('select[name="change_delivery"]').append(newOption).trigger('change.select2'); //trigger select2 change rather than normal change so our change function for model doesnt run every time it changes
        });
      }
    });

});

$('input[name="delivery_options"],select[name="change_delivery"]').on('change',function () {
    $('.preloader').css('display', 'block');

    $.ajax({
      type: 'POST',
      url: $(document.body).data('base') + '/ajax/product/change-delivery-service.php',
      data: {
        service: $(this).val()
      },
      success: function(response) {
        response = JSON.parse(response);

        $('.delivery-name-details').html(response.service_name);
        $('.delivery-days-details').html(response.service_days);
        // $('.estimated').html(response.estimated_delivery);
        $('.delivery-total').html(response.delivery_total);
        $('.total-vat').html(response.vat_total);
        $('.grand-total').html(response.grand_total);
        $('.discount-total').html(response.discount_total);
        $('.preloader').css('display', 'none');
      }
    });

});

$('input[name="register-login"]').on('change', function(e) {
  $('.cart__forms').removeClass('show');
  $('form[name="' + $(this).val() + '_form"]').addClass('show');
});

$('input[name="delivery_type"]').on('change', function(e) {
  $('.cart__delivery-option').removeClass('show');
  
  if ($(this).val() == 'click') {
    $('.cart__delivery-option.click').addClass('show');
  } else {
    $('.cart__delivery-option.delivery').addClass('show');
  }
});

$('.show-password').on('click', function (e) {
  e.preventDefault();

  if($(this).hasClass('active')) {
    $(this).html(`
        <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="14" viewBox="0 0 17.5 14"><path d="M4.121 2.537A7.467 7.467 0 0 1 8.75.875a7.7 7.7 0 0 1 5.266 2.2 10.593 10.593 0 0 1 2.54 3.585.87.87 0 0 1 0 .673 10.842 10.842 0 0 1-2.185 3.238l2.877 2.256a.656.656 0 1 1-.809 1.034L.251 1.173A.656.656 0 0 1 .14.25a.656.656 0 0 1 .921-.112l3.059 2.4ZM6.1 4.088l2.47 1.936a1.77 1.77 0 0 0 .18-.8 2 2 0 0 0-.23-.839 2.223 2.223 0 0 1 .23-.035 2.626 2.626 0 0 1 2.625 2.625 2.33 2.33 0 0 1-.243 1.075l1.08.826a3.943 3.943 0 0 0 .476-1.9A3.954 3.954 0 0 0 8.75 3.038a3.94 3.94 0 0 0-2.65 1.05Zm2.65 9.037a7.694 7.694 0 0 1-5.266-2.2A11.135 11.135 0 0 1 .942 7.336a.874.874 0 0 1 0-.673 10.4 10.4 0 0 1 1.33-2.248L4.851 6.45a4 4 0 0 0-.038.528 3.944 3.944 0 0 0 3.937 3.96 3.927 3.927 0 0 0 1.45-.277l2 1.575a7.188 7.188 0 0 1-3.45.889Z" fill="#5d5d5d"/></svg>
    `);
    $(this).removeClass('active');
    $(this).prev('input').attr('type', 'password');
  } else {
    $(this).html(`
        <svg xmlns="http://www.w3.org/2000/svg" width="15.749" height="12.25" viewBox="0 0 15.749 12.25"><path d="M7.645 3.511a2.153 2.153 0 0 1 .23-.011A2.61 2.61 0 0 1 10.5 6.125 2.626 2.626 0 0 1 7.875 8.75 2.61 2.61 0 0 1 5.25 6.125a2.153 2.153 0 0 1 .011-.23 2.007 2.007 0 0 0 .864.23 1.752 1.752 0 0 0 1.75-1.75 2.007 2.007 0 0 0-.23-.864Zm5.5-1.307a10.593 10.593 0 0 1 2.54 3.585.87.87 0 0 1 0 .673 11.086 11.086 0 0 1-2.54 3.585 7.694 7.694 0 0 1-5.27 2.203 7.692 7.692 0 0 1-5.266-2.2A11.129 11.129 0 0 1 .067 6.461a.874.874 0 0 1 0-.673 10.632 10.632 0 0 1 2.542-3.584 7.7 7.7 0 0 1 5.266-2.2 7.7 7.7 0 0 1 5.266 2.2Zm-5.27-.016a3.939 3.939 0 0 0-3.937 3.937 3.939 3.939 0 0 0 3.937 3.938 3.939 3.939 0 0 0 3.938-3.938 3.939 3.939 0 0 0-3.938-3.937Z" fill="#5d5d5d"/></svg>
    `);
    $(this).addClass('active');
    $(this).prev('input').attr('type', 'text');
  }
});

$('.toggle-bundle-details').on('click', function(e){
  e.preventDefault();
  
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $(this).find('i').removeClass('fa-caret-up').addClass('fa-caret-down');
    $('.cart__table--row--bundles').removeClass('show');
  } else {
    $(this).addClass('active');
    $(this).find('i').removeClass('fa-caret-down').addClass('fa-caret-up');
    $('.cart__table--row--bundles').addClass('show');
  }
})